import { formatIsoDateOnlyShort } from '@/app/utils/formatDate';

export function dueText(
    dueDate: string | null,
    dueMileage: number | null,
): { date: string | null; mileage: string | null } {
    return {
        date: dueDate ? formatIsoDateOnlyShort(dueDate) : null,
        mileage: dueMileage === null ? null : `${dueMileage.toLocaleString('en-GB')} mi`,
    };
}
